
// Initial score data for Level 1 Training

export const initialScores = {
  "putts-plat": {},
  "putts-montee": {},
  "putts-descente": {},
  "putts-pente": {},
  "putts-pente-droite": {},
  "chipping-plat": {},
  "chipping-pente-droit": {},
  "chipping-roulee-plat": {},
  "wedging-cercles": {},
  "wedging-pente-gauche": {},
  "bunker-court": {},
  "iron-long": {},
  "iron-mid": {},
  "iron-green-attack": {},
  "iron-green-attack-100": {},
  "fairwayWood-3": {},
  "fairwayWood-5": {},
  "driver-practice": {},
  "driver-accuracy": {}
};

export const levels = {
  "0": "Niveau 1 débutant",
  "120": "Niveau 1 intermédiaire",
  "240": "Niveau 1 avancé"
};
